<template>
  <div class="register-con" ref="register">
    <div class="logo-con">
      <img class="logo" :src="checkQiNiuUrl('ant-wx/202208101113/yungan_logo.png?imageView2/2/w/120/format/png/q/75')" alt="">
      <div class="logo-text">云柑社区</div>
    </div>



    <van-form
        class="register-form"
        ref="form"
        label-align="left"
        label-width="90"
        @submit="handlerSubmit"
    >
      <van-field
          name="mobileNumber"
          v-model="mobileNumber"
          clearable
          type="number"
          placeholder="请输入手机号码"
          :rules="[{required: true, message: '必填'}]"
      >
        <div class="area-label" slot="label" @click="areaPopupShow=true">
          <span class="area-tel">+{{ areaCodeItem.telPrefix }}</span>
          <span class="area-name">{{ areaCodeItem.name }}</span>
        </div>
      </van-field>

      <van-field
          v-model="smsCode"
          center
          clearable
          maxLengrh="4"
          type="number"
          label="验证码"
          placeholder="请输入短信验证码"
          :rules="[{required: true, message: '必填'}]"
      >
        <van-button slot="button" native-type="button" size="mini" type="info"
                    :disabled="isSend" @click="useVerify">{{ btnText }}</van-button>
      </van-field>

      <div class="btn-con">
        <van-button class="btn" type="info"
                    block round native-type="submit">下一步</van-button>
      </div>
    </van-form>

    <van-popup
        class="phone-area-popup"
        :getContainer="() => $refs.register"
        v-model="areaPopupShow"
        round
        :closeable="true"
        :style="{ width: '88%' }"
    >
      <div class="area-con">
        <div class="item" v-for="(item, i) in areaCodeList" :key="i"
             :class="{active: areaCode===item.telPrefix}" @click="selectArea(item)">
          <span class="tel">+{{ item.telPrefix }}</span>
          <span>({{ item.name }})</span>
        </div>
      </div>
    </van-popup>

    <Verify
        @success="success"
        :mode="'pop'"
        :captchaType="'clickWord'"
        :imgSize="{ width: '310px', height: '145.6px' }"
        ref="verify"
    />

  </div>
</template>

<script>
import Verify from "@/components/verifition/Verify";
import preventBack from 'vue-prevent-browser-back'
import { sendVerifyCode } from '@/api/mall/mallSystem'
import { phoneBindInviteCode, newBindLoginAccount, newUserRegister, } from '@/api/login'
import { memberInviteTargetOpenId } from '@/api/org'
import { mapGetters } from 'vuex'
export default {
  mixins: [preventBack],// 该页面禁止后退
  components: {
    Verify
  },
  data(){
    return{
      areaCode: '86',
      areaCodeItem: {
        telPrefix: '86',
        name: '中国',
      },
      areaCodeList: [],
      areaPopupShow: false,

      isSend: false,
      btnText: '发送验证码',
      time: 60,

      mobileNumber: '',
      smsCode: '',
      captchaVerification: '',
      inviteUserInfo: this.session('inviteUserInfo') || {},
      // 2022-01-04 ：
      user: this.session('user') || {}, // 当前登录用户
      seedBtn: false,
      btnFlag: false,

    }
  },
  computed: {
    ...mapGetters([
      'areaCodeData',
    ])
  },
  watch:{
    areaCodeData(val){
      this.areaCodeList = val
    }
  },
  created(){
    console.log('this.inviteUserInfo', this.inviteUserInfo)
    this.$store.dispatch('app/changeAreaCodeData', { status: true })
  },
  methods: {
    useVerify(){
      this.$refs['form'].validate('mobileNumber').then(()=>{
        this.$refs.verify.show()
      })
    },
    success(params){
      console.log(params.captchaVerification)
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
      this.captchaVerification = params.captchaVerification
      this.handlerGt()
    },
    timeDown(){
      let timer = window.setInterval(()=>{
        this.time--;
        this.btnText = '剩余 ' + this.time + ' 秒';
        if(this.time===0){
          window.clearInterval(timer);
          this.time = 60;
          this.btnText = '发送验证码';
          this.isSend = false
        }
      },1000)
    },
    handlerGt(){ //发送短信验证码
      if(this.seedBtn){
        return false
      }
      this.$refs['form'].validate('mobileNumber').then(()=>{
        this.seedBtn = true
        // 不通过极验调用：
        let phone = this.mobileNumber
        if(this.areaCode!=='86'){ // 处理区号
          phone = '+'+this.areaCode+'-'+phone
        }
        let req = {
          type: 'SMS',
          business: 'LOGIN',
          account: phone,
          captchaVerification: this.captchaVerification
        }
        sendVerifyCode(req).then(res=>{
          if (res.code === 200) {
            this.isSend = true;
            this.btnText = '剩余 ' + this.time + ' 秒';
            this.timeDown();
            this.$toast('验证码已发送，请查收短信！')
          } else if (res.code === 300) {
            this.$toast(res.message);
          } else {
            this.$toast(res.message);
          }
          window.setTimeout(()=>{
            this.seedBtn = false
          },2000)
        })
      })
    },
    handlerSubmit(){
      let req = {}
      if(this.btnFlag){
        return false
      }
      this.$refs['form'].validate().then(()=>{
        const toast = this.$toast.loading({
          duration: 0,
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
        })
        this.btnFlag = true
        if(this.user && this.user.wxUnionid){ // 新用户
          req = {
            avatar: this.user.avatar,
            bindPhone: {
              phone: this.mobileNumber,
              smsCode: this.smsCode
            },
            inviteCodeOnLevel1: this.inviteUserInfo.inviteCode,
            loginAccount: this.user.wxUnionid,
            loginType: 'WECHAT',
            nickname: this.user.nickname,
            sex: this.user.sex,
            tempCode: this.user.tempCode,
            wxExpand: {
              wxAppid: this.user.wxAppid,
              wxOpenid: this.user.wxOpenid
            },
          }
          if(this.areaCode!=='86'){ // 处理区号
            req.bindPhone.phone = '+'+this.areaCode+'-'+req.bindPhone.phone
          }
          newUserRegister(req).then(res=>{
            console.log('newUserRegister', res)
            let data = res.data;
            toast.clear();
            if(res.code===200){
              this.session('user',data);
              this.session('userOpenId', data.userOpenId)
              this.session('token', data.token)
              this.session('h5RegisterOk', true)
              // 邀请加入组织
              if(this.inviteUserInfo.orgMemberInviteId){
                this.memberInviteTargetOpenId({orgMemberInviteId: this.inviteUserInfo.orgMemberInviteId, userOpenId: this.session('user').userOpenId})
              }
              // 跳转至下载页面
              this.$router.replace({ name: 'h5RegisterDownload' })
            }else if(res.code===400){ // 该帐号已绑定过，请重新选择其它帐号
              this.$toast({message: '该号码已被注册/绑定，请更换新号码后重新尝试', duration: 4000})
              window.setTimeout(()=>{
                this.btnFlag = false
              },1000)
            }else {
              this.$toast(res.message)
              window.setTimeout(()=>{
                this.btnFlag = false
              },1000)
            }
          })
        }else if(this.user && this.user.userOpenId  && !this.user.phone){ // 已微信注册的账号，绑定手机号
          req = {
            loginType: 'MOBLIE',
            loginByVerifyCode: {
              loginAccount: this.mobileNumber,
              verifyCode: this.smsCode
            }
          }
          if(this.areaCode!=='86'){ // 处理区号
            req.loginByVerifyCode.loginAccount = '+'+this.areaCode+'-'+req.loginByVerifyCode.loginAccount
          }
          newBindLoginAccount(req).then(res=>{
            console.log('newBindLoginAccount', res)
            toast.clear();
            if(res.code===200){
              let user = this.session('user')
              this.session('userOpenId', user.userOpenId)
              this.session('token', user.token)
              this.session('h5RegisterOk', true)
              // 邀请加入组织
              if(this.inviteUserInfo.orgMemberInviteId){
                this.memberInviteTargetOpenId({orgMemberInviteId: this.inviteUserInfo.orgMemberInviteId, userOpenId: this.session('user').userOpenId})
              }
              // 跳转至下载页面
              this.$router.replace({ name: 'h5RegisterDownload' })
            }else if(res.code===400){ // 该帐号已绑定过，请重新选择其它帐号
              this.$toast({message: '该号码已被注册/绑定，请更换新号码后重新尝试', duration: 4000})
              window.setTimeout(()=>{
                this.btnFlag = false
              },1000)
            }else {
              this.$toast(res.message)
              window.setTimeout(()=>{
                this.btnFlag = false
              },1000)
            }
          })
        }else {
          req = {
            mobileNumber: this.mobileNumber,
            smsCode: this.smsCode,
            registerinvitecode: this.inviteUserInfo.inviteCode,
          }
          if(this.areaCode!=='86'){ // 处理区号
            req.mobileNumber = '+'+this.areaCode+'-'+req.mobileNumber
          }
          if(this.inviteUserInfo.tid){
            req.tid = this.inviteUserInfo.tid
          }
          if(this.inviteUserInfo.orgMemberInviteId){
            this.memberInviteTargetOpenId({orgMemberInviteId: this.inviteUserInfo.orgMemberInviteId, phone: req.mobileNumber})
          }
          phoneBindInviteCode(req).then(res=>{
            // this.$toast(res.message)
            toast.clear();
            if(res.code===200 || res.code===300){
              this.$router.push({ name: 'h5RegisterDownload' })
            }
            window.setTimeout(()=>{
              this.btnFlag = false
            },1000)
          })
        }
      })
    },

    // 上报后台发送 APP 加入组织的通知
    memberInviteTargetOpenId(req){
      memberInviteTargetOpenId(req).then(res=>{
        console.log('memberInviteTargetOpenId----res-->>', res)
      })
    },

    selectArea(item){
      this.areaCodeItem = item
      this.areaCode = item.telPrefix
      this.areaPopupShow = false
    },

  }
}
</script>

<style lang="less" scoped>
.register-con{
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
  background-color: #fff3e6;
  //background: url("@{qnUrl}ant-wx/202208101113/wx_register_bg.png") no-repeat 0 0;
  //background-size: 100% 100%;
  color: #333;
  .logo-con{
    width: 100%;
    height: 160px;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .logo{
      width: 60px;
      height: 60px;
    }
    .logo-text{
      text-align: center;
      font-size: 18px;
      line-height: 35px;
      color: #444;
    }
    &.user-con{
      .img{
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-bottom: 6px;
      }
      .nickname{
        text-align: center;
        font-size: 16px;
        line-height: 20px;
        color: #000;
      }
      .text{
        text-align: center;
        font-size: 14px;
        color: #555;
      }
    }
  }

  .register-form{
    width: 355px;
    padding: 20px 0 0;
    margin: 20px auto 0;
    border-radius: 14px;
    /deep/ .van-cell{
      background: transparent;
    }
    /deep/ .van-cell::after{
      border-color: #a4a4a4;
    }
    .area-label{
      display: flex;
      flex-direction: column;
      .area-tel{
        padding-bottom: 2px;
        font-size: 16px;
        line-height: 1;
      }
      .area-name{
        font-size: 10px;
        line-height: 1;
      }
    }
    .btn-con{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 20px;
      .btn{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        //background: transparent;
        margin-bottom: 20px;
        color: #fff;
        width: 315px;
        height: 50px;
        border-radius: 25px;
        border: 2px solid #ffffff;
      }
    }
  }

  .phone-area-popup{
    border-radius: 12px;
    background-color: rgba(255,255,255,1);
    .area-con{
      margin-top: 40px;
      font-size: 14px;
      height: 50vh;overflow-y: auto;
      .item{
        padding: 10px 12px;
        border-bottom: 0.7px solid #f5f5f5;
        color: #747474;
        &.active{color: #00a6ff;}
        &:last-child{
          border-bottom: none;
        }
        .tel{display: inline-flex;min-width: 50px;}
      }
    }
  }
}
</style>
